const QUOTES = [
  "Heal Loud.",
  "Recovery, Reimagined.",
  "Injured, Not Invisible.",
  "Comeback Season.",
  "Built to Heal. Designed to Live In.",
  "Still Iconic. Just Healing.",
  "Torn, Not Broken.",
  "Support That Doesn't Look Like a Setback.",
  "Bounce Back Different.",
  "Odourless Knit.",
  "Itch-Free. Always.",
];

export const Marquee = () => (
  <div
    data-testid="quote-marquee"
    className="overflow-hidden border-y border-[#2C241E]/10 py-5 md:py-6"
  >
    <div className="marquee-track flex items-center gap-8 md:gap-12 whitespace-nowrap">
      {[...QUOTES, ...QUOTES].map((q, i) => (
        <span key={i} className="flex items-center gap-8 md:gap-12">
          <span className="font-display italic text-lg md:text-2xl text-[#2C241E]/70">{q}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-[#A07856]" />
        </span>
      ))}
    </div>
  </div>
);
